import axios, { AxiosResponse } from "axios";
import { PmInterface } from "../../common/interfaces/common";
import { get200ErrorMsg, getErrorMsg } from "../../common/utils/request";
import { CategoryListResponse } from "../interfaces/http-responses";

declare var pm: PmInterface;

export const fetchSpecificCategories = async (
	ids: Array<number>,
	nonce: string,
): Promise<CategoryListResponse> => {
	const formData = new FormData();

	formData.append("action", "pm_fetch_specific_categories");
	formData.append("nonce", nonce);
	formData.append("ids", ids.join(", ").trim());

	try {
		const axiosResponse: AxiosResponse<any> = await axios({
			method: "post",
			url: pm.ajaxurl,
			data: formData,
		});

		if (!axiosResponse.data || !axiosResponse.data.success) {
			return {
				success: false,
				message: get200ErrorMsg(axiosResponse),
				data: [],
			};
		}

		return axiosResponse.data;
	} catch (response: any) {
		return {
			success: false,
			message: getErrorMsg(response),
			data: [],
		};
	}
};
